import { useEffect, useState } from 'react';
import styles from './myAchieve.module.css';
import { AchievementCard } from '../../components/MyAchieve';
import { getMyAchievements } from '../../api/achievements';
import achievemy from '../../assets/icons/achievemy.svg';

export const MyAchieve = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    async function loadAchievements() {
      try {
        setError('');
        const response = await getMyAchievements();
        setItems(response?.items || []);
      } catch (err) {
        setError(err.message || 'Не удалось загрузить достижения.');
      } finally {
        setLoading(false);
      }
    }

    loadAchievements();
  }, []);

  return (
    <div className={styles.container}>
      <div>
        <h2 className={styles.title}>Мои достижения</h2>
        {loading ? <p className={styles.emptyText}>Загружаем достижения...</p> : null}
        {error ? <p className={styles.errorText}>{error}</p> : null}
        {!loading && !error && !items.length ? (
          <p className={styles.emptyText}>
            Пока здесь ничего нет. Выполняй задания и активности, чтобы получить первые достижения.
          </p>
        ) : null}
        {!loading && !error && items.length ? (
          <div className={styles.achievementsGrid}>
            {items.map((achievement) => (
              <AchievementCard
                key={achievement.achievement_id}
                title={achievement.title}
                description={achievement.description}
                image={achievement.image_url || achievemy}
                isLocked={achievement.status !== 'received'}
                statusText={achievement.status === 'received' ? 'Получено' : 'Пока не получено'}
                coinAmount={
                  achievement.coin_amount
                  ?? achievement.reward_amount
                  ?? achievement.reward_points
                  ?? achievement.points
                  ?? null
                }
              />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};
